module.exports = "<div [class.invalid]=\"!valid && showValidationErrors\">\r\n  <ng-content></ng-content>\r\n  <small *ngIf=\"showValidationErrors && !valid\" class=\"help-block\" data-bv-validator=\"notEmpty\" data-bv-result=\"INVALID\">{{ errorMessage }}</small>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/field-validation-message/field-validation-message.component.html
// module id = ./src/app/shared/components/field-validation-message/field-validation-message.component.html
// module chunks = main